// @flow
import {
  LOG_OUT,
  RETRIEVE_PROFILE_FAILED,
  RETRIEVE_PROFILE_START,
  RETRIEVE_PROFILE_SUCCESS,
  RETRIEVE_TEAM_FAILED,
  RETRIEVE_TEAM_START,
  RETRIEVE_TEAM_SUCCESS,
  RETRIEVE_TOKEN_FAILED,
  RETRIEVE_TOKEN_START,
  RETRIEVE_TOKEN_SUCCESS,
  REVIVE_TOKEN_SUCCESS,
  SAML_TOKEN_FAILED,
  SAML_TOKEN_START,
  SAML_TOKEN_SUCCESS,
  SEND_LOG_ACCESS_FAILED,
  SEND_LOG_ACCESS_SUCCESS,
} from '../actions/session';

import type { Action } from './types';

const initialState = {
    user: null,
    uid: null,
    token: null,
    isRetrievingToken: false,
    isLoadSamlToken: false,
    errorMessage: null,
    errorCode: null,
    integratorHasAccess: false,
    canExecute: false,
    canDelete: false,
};

//Reducer that manages the downloads in the application
export default function session( state = initialState, action: Action ) {
    switch ( action.type ) {
        case SAML_TOKEN_START:
        case RETRIEVE_TOKEN_START:
            return {
                ...state,
                errorMessage: null,
                errorCode: null,
                isRetrievingToken: true,
                isLoadSamlToken: action.type === SAML_TOKEN_START
            };
        case SAML_TOKEN_SUCCESS:
        case RETRIEVE_TOKEN_SUCCESS:
            console.log('action.result', action.result)
            localStorage.setItem( 'token', action.result.jwt_access_token );
            localStorage.setItem( 'username', action.result.username );
            localStorage.setItem( 'isEmployee', action.result.is_employee );
            localStorage.setItem( 'roles', action.result.roles );
            localStorage.setItem( 'salesOrgs', action.result.salesOrgs );
            let output = {
                ...state,
                user: action.result.current_user.name,
                uid: action.result.current_user.uid,
                token: action.result.jwt_access_token,
                isRetrievingToken: false,
                isLoadSamlToken: false,
                isEmployee: action.result.is_employee
            }

            if ( process.env.REACT_APP_SEE_TICKETS === "1" ) {
                localStorage.setItem( 'userUUID', action.result.uuid );
                if ( action.result.permissions.includes( "ticketing__can_request" ) ) {
                    localStorage.setItem( 'ticketingUUID', action.result.ticketing_systems[0] );
                    if ( action.result.employee_sap_profile_uuid !== null ) {
                        localStorage.setItem( 'profileUUID', action.result.employee_sap_profile_uuid )
                    }
                }

                const isExecutorFromDrupal =   action.result.permissions.includes( "ticketing__can_execute_request" ) || action.result.permissions.includes( "ticketing__can_exectute_request" );
                const canDeleteFromDrupal = action.result.permissions.includes("ticketing__can_execute_delete");

                output = {
                    ...output,
                    userUUID: action.result.uuid,
                    ticketingUUID: action.result.permissions.includes( "ticketing__can_request" ) ? action.result.ticketing_systems[0] : undefined,
                    canExecute: isExecutorFromDrupal,
                    canDelete: canDeleteFromDrupal,
                    profileUUID: action.result.employee_sap_profile_uuid !== null ? action.result.employee_sap_profile_uuid : undefined,
                }
                localStorage.setItem('canExecute', JSON.stringify(output.canExecute));
                localStorage.setItem('canDelete', JSON.stringify(output.canDelete));
            }

            return output;
        case SAML_TOKEN_FAILED:
        case RETRIEVE_TOKEN_FAILED:
            return {
                ...state,
                errorMessage: action.error.statusText,
                errorCode: action.error.code || null,
                isRetrievingToken: false,
                isLoadSamlToken: false
            };
        case RETRIEVE_PROFILE_START:
            return { ...state, errorMessage: null }
        case RETRIEVE_PROFILE_SUCCESS:
            if ( action.result.errors ) {
                return { ...state, errorMessage: action.result.errors[0].detail };
            }
            return {
                ...state,
                fullname: action.result.data.attributes.field_employee_sap_fullname,
                email: action.result.data.attributes.field_employee_sap_email,
                phone: action.result.data.attributes.field_employee_sap_phone,
                company: action.result.data.attributes.field_employee_sap_company,
                jobTitle: action.result.data.attributes.field_employee_sap_job_title,
                salesOrg: action.result.included[0].attributes.label.replace( "Werfen ", "" ),
                salesOrgUUID: action.result.included[0].id
            }
        case RETRIEVE_PROFILE_FAILED:
            return { ...state, errorMessage: action.error.statusText };
        case RETRIEVE_TEAM_START:
            return { ...state, errorMessage: null }
        case RETRIEVE_TEAM_SUCCESS:
            if ( action.result && action.result.data[0] ) {
                localStorage.setItem( 'teamUUID', action.result.data[0].id );
            }
            return {
                ...state,
                teamUUID: action.result.data[0] ? action.result.data[0].id : undefined,
            }
        case RETRIEVE_TEAM_FAILED:
            return { ...state, errorMessage: action.error.statusText };

        case REVIVE_TOKEN_SUCCESS:

            const canExecuteFromStore = JSON.parse(localStorage.getItem('canExecute')) || false;
            const canDeleteFromStore = JSON.parse(localStorage.getItem('canDelete')) || false;
            return {
                ...state,
                user: action.payload.current_user,
                token: action.payload.jwt_access_token,
                userUUID: action.payload.userUUID || undefined,
                ticketingUUID: action.payload.ticketingUUID || undefined,
                teamUUID: action.payload.teamUUID || undefined,
                canExecute: canExecuteFromStore,
                canDelete: canDeleteFromStore,
                profileUUID: (action.payload.profileUUID !== null && action.payload.profileUUID !== undefined) ? action.payload.profileUUID : undefined,
                isEmployee: action.payload.isEmployee,
                isRetrievingToken: false,
            };
        case LOG_OUT:
            localStorage.removeItem( 'token' );
            localStorage.removeItem( 'username' );
            localStorage.removeItem( 'userUUID' );
            localStorage.removeItem( 'teamUUID' );
            localStorage.removeItem( 'ticketingUUID' );
            localStorage.removeItem( 'profileUUID' );
            localStorage.removeItem( 'isEmployee' );
            localStorage.removeItem('integradoresReasons');
            localStorage.removeItem('canExecute');
            localStorage.removeItem('canDelete');
            return { ...state, user: null, token: null, isRetrievingToken: false };
        case SEND_LOG_ACCESS_SUCCESS:
            localStorage.removeItem('integradoresReasons');
            return{...state, integratorHasAccess: true};
        case SEND_LOG_ACCESS_FAILED:
            localStorage.removeItem('integradoresReasons');
            return { ...state, errorMessage: action.error.statusText };
        default:
            return state;
    }
}
